// eslint-disable-next-line @typescript-eslint/no-restricted-imports
import type { PostHogConfig, PostHogInterface } from 'posthog-js';

const apiHost =
  process.env.NEXT_PUBLIC_POSTHOG_API_HOST || 'https://us.i.posthog.com';
const uiHost =
  process.env.NEXT_PUBLIC_POSTHOG_UI_HOST || 'https://us.posthog.com';
const autocapture = process.env.NEXT_PUBLIC_POSTHOG_AUTOCAPTURE === 'true';

function handlePosthogLoaded(posthog: PostHogInterface) {
  const shouldEnableDebug =
    process.env.NODE_ENV !== 'production' &&
    process.env.NEXT_PUBLIC_POSTHOG_ENABLE_DEBUG_OUTPUT === 'true';

  if (shouldEnableDebug) {
    posthog.debug(true);
  } else {
    posthog.debug(false);
  }
}

export const posthogConfigAppRouter: Partial<PostHogConfig> = {
  api_host: apiHost,
  ui_host: uiHost,
  autocapture,
  person_profiles: 'identified_only',
  capture_pageview: false, // Disable automatic pageview capture, as we capture manually
  capture_pageleave: true, // Enable pageleave capture
  loaded: handlePosthogLoaded,
};

export const posthogConfigPagesRouter: Partial<PostHogConfig> = {
  api_host: apiHost,
  ui_host: uiHost,
  autocapture,
  person_profiles: 'identified_only',
  loaded: handlePosthogLoaded,
};
